var map = {
	"vs/language/css/cssWorker": 755,
	"vs/language/html/htmlWorker": 774,
	"vs/language/json/jsonWorker": 786,
	"vs/language/typescript/src/worker": 800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 754;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/editor/common/services
// module id = 754
// module chunks = 0